export default __webpack_public_path__ + "static/media/avatar-bot.0f686821.png";